import { ValidatorFn } from "@angular/forms";

export class TinyMceSetupConfiguration {

  initialValue: string | null = null;
  validators: ValidatorFn | ValidatorFn[] | null = null;
  file: File | null = null;
  templateManagementEnabled: boolean = true;

  private constructor() {
  }

  public static create = (): TinyMceSetupConfiguration => new TinyMceSetupConfiguration();

  setTemplateManagementEnabled(value: boolean) {

    this.templateManagementEnabled = value;
    return this;

  }

  setInitialValue(value: string | null): TinyMceSetupConfiguration {

    this.initialValue = value;
    return this;

  }

  setValidators(value: ValidatorFn | ValidatorFn[] | null): TinyMceSetupConfiguration {

    this.validators = value;
    return this;

  }

  setFile(value: File | null): TinyMceSetupConfiguration {

    this.file = value;
    return this;

  }

}
